import config from 'config';
import {api} from './api';

export const operationsService = (parameter: any) => {
    
    api.defaults.baseURL = config.operationsServiceBaseURL;
    return api.get(`operations/${parameter}`);
}
